import { cssClass } from '../../style';
import { TypeStyle, classes } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

const cssPrefix = 'AnalyticsExtensionsSettings';

export namespace AnalyticsExtensionsSettingsStyles {

    export const enableForSite = cssClass(cssPrefix, 'enable-for-site', {
        margin: '10px 0 10px 0'
      });

    export const connectionSettingsTable = cssClass(cssPrefix, 'connection-settings-table', {
        display: 'table',
        width: '100%'
      });

    export const connectionSettingsRow = cssClass(cssPrefix, 'connection-settings-row', {
        display: 'table-row',
        fontWeight: 'bold',
        margin: '4px 0px 4px 0'
      });

    export const connectionSettingsCell = cssClass(cssPrefix, 'connection-setting-cell', {
      display: 'table-cell',
      //position: 'relative',
      padding: '0px 5px 0px 5px',
      verticalAlign: 'bottom'
    });

    export const connectionSettingsCheckBox = cssClass(cssPrefix, 'connection-setting-checkbox-visible', {

    });

    export const Hide = cssClass(cssPrefix, 'connection-setting-checkbox-hidden', {
     display: 'none'
    });

    export const connectionPortInput = cssClass(cssPrefix, 'connection-port-input', {
      $nest: {
        '& input': {
          width: '60px'
        }
      }
    });

    export const connectionSslCheckbox: React.CSSProperties = {
      width: '96px'
    };
}
